var search = require('./search');
var updateFilterAccessibility = require('./update-filter-accessibility');
var handleModalFilters = require('./handle-modal-filters');

module.exports = function (apiEndpoint) {
    
    search(function (results) {
        var $searchRendering = $('.search-rendering');
        var $oldInner = $($searchRendering).find('.search-rendering_search-page-inner');

        $expandedFilterButtons = $('.search-rendering__filter--expanded > div:first-child > button');
        var expandedFilterButtonIds = [];
        $expandedFilterButtons.each(function () {
            expandedFilterButtonIds.push(('#' + this.id));
        });

        $oldInner.remove();
        $searchRendering.append(results);                       
        
        $(expandedFilterButtonIds.join(', ')).parents('.search-rendering__filter--expandable').addClass('search-rendering__filter--expanded');
        updateFilterAccessibility($searchRendering.find('.search-rendering__filters-wrapper'));

        if (window.lastSearchRenderingFocusId && window.lastSearchRenderingFocusId.length) {
            $('#' + window.lastSearchRenderingFocusId).focus();
            window.lastSearchRenderingFocusId = '';
        }
        else if (window.page > 1) {        
            $('.search-rendering__result').slice((window.page - 1) * 10).first().find('.search-rendering__result-title').focus();
        };

        handleModalFilters(apiEndpoint);

    }, apiEndpoint);
    
};